<template>
    <div>
        <topnav @tosearch="tosearch" :keywords="keyword" :isSearch="path"></topnav>
        <div class="">
            <div class="" v-if="config">
                <el-image class="topimg" :src="config.tzzximage | addurl" fit="fill"></el-image>
            </div>
       <!--   <div class="marginauto conwidth nav-list animated slideInRight  ">
             <div class="nav-list  marginauto conwidth animated slideInRight box">
                 <div @click="tabchange(1)" style="width: 33.33%;display: flex;align-items: center;justify-content: center;">
                     <div class="box_cent" :class="type==1?'sty':''">通知</div>
                 </div>
                 <div @click="tabchange(2)" style="width: 33.33%;display: flex;align-items: center;justify-content: center;">
                     <div class="box_cent" :class="type==2?'sty':''">咨询</div>
                 </div>
             </div>
          </div> -->
            <div v-if="list.length" class="response bggray">
                <div class="conwidth marginauto lall fadeInDown animated">
                    <div v-for="(item,index) in list" :key="index" @click="todetail(item.id,tabindex)" class="marginauto bg-white flex justify-between align-center lone hvr-float">
                      <!--  <div class="limg pointer ">
                            <el-image class="cimg" :src="item.image | addurl" fit="cover"></el-image>
                        </div>
                        <div class="line"></div> -->
                        <div class="pointer" style="min-height: 123px;padding-left: 30px;width: 100%;">
                            <div>
                                <div class="" style="color: #1d1d1d;font-size: 22px;">{{item.title}}</div>
                                <div class="text-cut2 response" style="margin: 15px 0;min-height: 42px;line-height: 30px">
                                    {{item.content}}
                                </div>
                                <div class="flex justify-between align-center">
                                    <div style="color: rgb(136, 136, 136);font-size: 18px;">
                                      发布日期：<span>{{item.createtime}}</span>
                                    </div>
                                    <div class="dbtn pointer">
                                        查看详情
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center res" style="padding: 40px 0;">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :pager-count="pagerCount"
                            :hide-on-single-page="true"
                            :page-size="pagesize"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :total="totalnum"
                            >
                            </el-pagination>
                    </div>
                </div>
            </div>
            <div class="" v-if="!list.length && !load">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    data() {
        return{
			type:1,
			tabindex:0,
            load: true,
            toptype: 6,
            pagesize: 10,
            totalnum: 100,
            currentPage: 1,
            pagerCount: 7,
            list: [],
            config: '',
            keyword: '',
            path: '/finance',
			sortlist:[
				{
				    id: 1,
				    name: '通知'
				},
				{
				    id: 2,
				    name: '咨询 '
				}
			],
			type_id:0
        }
    },
    methods:{
		tabchange(e){
		    this.type = e;
		    this.keyword = '';
		    this.getlist();
		    this.$forceUpdate();
		},
        todetail(id){
           let routeData = this.$router.resolve({
               name: "policydetail",
               query: { id: id, type: this.type },
           });
           window.open(routeData.href, "_blank");
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.getlist();
        },
        getlist(){
            // finance_list
            var data = {
                start: this.currentPage,
                page_size: this.pagesize,
                keyword: this.keyword,
				type:this.type
            }
            this.$api.index.notice_list(data).then(response => {
                this.list = response.data;
                this.totalnum = response.count;
                this.load = false;
            })
        },
        tosearch(data){
            console.log(data)
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
    },
    created(){
		this.type = this.$route.query.type
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword;
            this.list = [];
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist()
        }else{
            this.getlist();
        }
		
        this.config = JSON.parse(localStorage.getItem('config'))
    }
}
</script>
<style scoped>
	.box {
	    height: 100px;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
	.box_cent {
	    width: 36%;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    cursor: pointer;
	    height: 100%;
	    transition: 1s;
	    height: 70px;
	    border-bottom: 2px solid #fff;
	}
	.sty {
	    border-bottom: 2px solid #1759d8;
	    /* color: #fff; */
	}
	.topall{
	    padding: 45px 0;
	    background-color: #fff;
	}
	.topone{
	    padding: 8px 18px;font-size: 16px;color: #4e4e4e;
	}
    .bggray{
        background-color: #eef1fa;
    }
	.active{
	    background-color: #ebf8ff;
	    border-radius: 4px;color: #1759d8;
	}
    .topimg{
        width: 100%;height: 500px;display: block;
    }
    .dbtn{
        width: 200px;
        height: 45px;text-align: center;
        line-height: 45px;color: #fff;
        background-color: #0e6cec;
        border-radius: 4px;font-size: 16px;
    }
    .lall{
        min-height: 400px;padding-top: 45px;
    }
    .lone{
        width: 1280px;padding: 38px 20px;border-radius: 10px;margin-bottom: 20px;
    }
    .limg{
        height: 123px;width: 185px;
    }
    .cimg{
        width: 160px;height: 123px;
    }
    .line{
        width: 1px;height: 123px;background-color: #eeeeee;
    }
</style>


// WEBPACK FOOTER //
// noticelist.vue?39f9d0d5